import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";

import men_print from "../../men_print.png"
import Print from "./Print";
import InputPostCode from "../../helpers/InputPostCode";
import MenuTable from "../../helpers/MenuTable";
import InputSearchEmp from "../../helpers/InputSearchEmp";



export default function Settings(props)
{


       const [errTab, setErrTab] = useState([]);  //z info od serwera..  
       const [row, setRowX] = useState(props.row);

       const [emps, setEmps] = useState([]);

       const [newEmp,setNewEmp] = useState('');


       const [showPrint, setShowPrint] = useState({
        show: 0,
        typ: 'pdf-1',
        title: '',
       });


   const [filterParam, setFilterParam] = useState({ 
        id: props.row.id, 
        tytul: props.mainView.readFilter('tytul',''),             
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);



       const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        
     const valChangeListenerEmp = (filedName, val, correct, msg) => {         
            
              setNewEmp(val);   
              addEmps(val);          
        } 


     const valChangeListenerRow = (filedName, val, correct, msg) => {         
             console.log("valChangeListenerRow: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                        
         
             setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );              
        } 
        const goNextNew = () => {
            console.log("goNext");    
           // setTab(null);    
        }





const getTabHistory = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_men,book_history', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);             
                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const getEmps = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_men,book_emp', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setEmps(res.result);                                      
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


const addEmps = (val) => {

    if(val.length < 2) return;

    var sp = val.split(" | ");

    if(sp.length != 2) return;

      var req = {
                    men_dziennik_id: props.id,
                    px_group_id: sp[0],
            }

 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_men,book_emp_add', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    getEmps();   
                    props.mainView.showDialog( "Sukces", "Nauczyciel został przypisany", "ok" ,  (pppp)=>{
                       
                    } );    
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}





  const arch = (e) => {

  
         
             
            props.mainView.showDialog("Potwierdź", "Potwierdź operacje kodem SMS:", "auth", (crypt)=>{
            
                ///--------
                if(crypt != null) 
                    {
                                   


                                                props.mainView.setProgress(-2);
                                        
                                                var req = {
                                                        men_dziennik_id: props.id,
                                                        crypt: crypt               
                                                }


                                        
                                                fetch( Config.url + '/rest_v1_men,book_arch', {
                                                    method: 'POST', 
                                                    body: JSON.stringify(req), 
                                                    headers: {
                                                        'Content-Type': 'application/json',                    
                                                        'X-Api-Key': props.userData.apiKey,
                                                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                                                        '_sec_key_': Config.genXKey() ,
                                                    }
                                                })
                                                .then(res => res.json() )
                                                .then(res => {             
                                                            
                                                            props.mainView.setProgress(-1);
                                        
                                                            if(res._sys_ == undefined)
                                                            {
                                                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                            }else
                                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                            {
                                                            // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                                            setErrTab(res.result);
                                                            }else
                                                            if(res.status != undefined && res.status == "OK")
                                                            {                          
                                                            props.mainView.showDialog( "Sukces",  "Dziennik został przeniesiony do archiwum", "ok" , null);                                                   
                                                            if(props.onSuccess != undefined) props.onSuccess();

                                                            }else
                                                            {
                                                                props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                                            }
                                                        
                                                } )
                                                .catch(err => {   
                                                            props.mainView.setProgress(-1);       
                                                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                                });
                   




                    }
                //--------
            },  "Archiwizacja dziennika " + row.nazwa_wlasna + " " + row.rok_szkolny   );
            
            



          
               
    
             return false;
    
        }  




        const saveData = () => {

 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
            if(row.nazwa_wlasna.length < 2)
            {
                 props.mainView.showDialog( "Error", "Podaj nową nazwę" , "ok" , null);  
                 return;
            }

             if(row.rok_szkolny.length < 2)
            {
                 props.mainView.showDialog( "Error", "Podaj rok szkolny" , "ok" , null);  
                 return;
            }

    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_men,book_update', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                          //  setView({v:'list',id:-1});
                            props.mainView.showDialog( "Sukces",  "Informacje zostały zapisane.", "ok" , null);                        
                           // getTab();
                           if(props.onSuccess != undefined) props.onSuccess();

                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }    



        
        const delEmp = (e) => {

 
            var tmpId = e.target.getAttribute('id');

          
            props.mainView.setProgress(-2);
    
            var req = {
                    men_dziennik_id: props.id,
                    px_group_id: tmpId,
            }
    
            fetch( Config.url + '/rest_v1_men,book_emp_remove', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                           getEmps();
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }   


    const goPrint = (e) => {

        var typ   = e.target.getAttribute('type');
        var title = e.target.getAttribute('title');


        if(showPrint.show == 1) 
        {

             setShowPrint({
                show: 0,
                typ: typ,
                title: title,
             });

        }
        else
        {
              setShowPrint({
                show: 1,
                typ: typ,
                title: title,
              });
        }


    }

    const closePrint = () => {
        setShowPrint({
        show: 0,
        typ: 'pdf-1',
        title: '',
       });
    }


        const itemsStatusy = [
            { v: 'aktywny', title: "Aktywny"},
            { v: 'nieaktywny', title: "Archiwalny"},
        ];


        if(tab == null )
        {
            setTab([]);

            
            getTabHistory();
            getEmps();
            
        }


        var printView = null;
        if(showPrint.show == 1) printView = <Print userData={props.userData} mainView={props.mainView} id={props.id}  typ={showPrint.typ} title={showPrint.title}  onClose={closePrint} />

 

    return <div>


                <div>
                    <h3>Wydruk i eksport danych</h3>


                     <div className="btn" onClick={arch}>ARCHIWIZUJ*</div>   &nbsp;&nbsp;
                        
                     <span onClick={goPrint}  type={props.typ == "specjalisty" ? "pdf-1-specjalisty" : "pdf-1"} title="Dziennik.pdf" className="link_color">Drukuj .PDF</span>
                     {printView}

                     &nbsp; &nbsp;
                     &nbsp; &nbsp;

                     <span onClick={goPrint}  type="xml-dziennik" title="Dziennik.xml" className="link_color">Dziennik .XML</span>
                     &nbsp;  &nbsp; &nbsp;
                     <span onClick={goPrint}  type="xml-ksiega-uczniow" title="KsięgaUczniow.xml" className="link_color">Księga uczniów .XML</span>


                </div>

                <br/>
                <div>
                    *Archiwizacja dziennika  <span className="amount_minus gobold">uniemożliwi</span> jego dalszą edycje. Możliwe będzie jedynie przeglądanie zawartości dziennika. 
                </div>

                <br/>
                <div>
                    <b>Podpisz dziennik - Profil zaufany i podpis zaufany </b>
                    <br/>
                    <p>
                        Profil zaufany to bezpłatne narzędzie, dzięki któremu możesz potwierdzić swoją tożsamość w systemach elektronicznej administracji oraz podpisać dokument podpisem zaufanym. 
                        Pobierz wybrany dokument PDF lub XML, zapisz go na komputarze a następnie podpisz profilem zaufanym. 
                        <br/>
                        <a href="https://pz.gov.pl/dt/login/login?urlt=bmrvmtewbvcdwathwpvp" target="_blank">Zalguj się do profilu zaufanego</a>  
                        &nbsp; &nbsp; &nbsp; 
                         <a href="https://www.gov.pl/web/gov/podpisz-dokument-elektronicznie-wykorzystaj-podpis-zaufany?utm_source=google-seach&utm_medium=cpc&utm_campaign=podpis-zaufany-sierpien&utm_content=search&gad_source=1&gad_campaignid=22360124153&gbraid=0AAAAA-sjM9MHOXSPecTeMrws7ODt2Za_p&gclid=EAIaIQobChMIxaqX-52UjwMVBkiRBR0A9DpiEAAYASAAEgIH-_D_BwE" target="_blank">Więcej informacji </a>  
                    </p>
                </div>

               

                <br/>
                <br/>

              {
                props.userData.type  == 'DYREKTOR' &&
                <Fragment>




    <div className="form_title">Ustawienia dziennika</div>
                <div className="form_tab">
                        
                             <div className="form_tab">


                                            <div className="form_control">
                                                    <div className="fieldName">Nowa nazwa dziennika*</div>
                                                    <InputText   userData={props.userData} value={row.nazwa_wlasna} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="nazwa_wlasna" placeholder={""} className=' w300 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Rok szkolny*</div>
                                                    <InputText   userData={props.userData} value={row.rok_szkolny} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="rok_szkolny" placeholder={""} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                          

                                            

                             </div>

                            <div className="form_title">Podmiot prowadzący</div>
                            <div className="form_tab">
                        
                                            <div className="form_control">
                                                    <div className="fieldName">Nazwa*</div>
                                                    <InputText   userData={props.userData} value={row.podmiot_nazwa} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podmiot_nazwa" placeholder={""} className=' w300 ' req='1' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                    <div className="fieldName">Ulica, nr domu*</div>
                                                    <InputText   userData={props.userData} value={row.podmiot_ulica_nr_domu} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podmiot_ulica_nr_domu" placeholder={""} className=' w100 ' req='1' firstUp="0" />
                                            </div>

                                              <div className="form_control">
                                                    <div className="fieldName">Kod pocztowy*</div>
                                                    <InputPostCode  userData={props.userData} value={row.podmiot_kod_pocztowy} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podmiot_kod_pocztowy" placeholder={""} className='  ' req='1' firstUp="0" />
                                            </div>

                                             <div className="form_control">
                                                    <div className="fieldName">Miasto*</div>
                                                    <InputText   userData={props.userData} value={row.podmiot_miasto} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podmiot_miasto" placeholder={""} className=' w100 ' req='1' firstUp="0" />
                                            </div>
                            
                                            <div className="form_control">
                                                    <div className="fieldName">Nazwa oddziału / Adres / Nazwa grupy*</div>
                                                    <InputText   userData={props.userData} value={row.podmiot_odzial_info} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="podmiot_odzial_info" placeholder={""} className=' w400 ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                    <div className="fieldName">Imię i nazwisko dyrektora*</div>
                                                    <InputText   userData={props.userData} value={row.dyrektor} err={errTab}  valChange={valChangeListenerRow} goNext={goNextNew} name="dyrektor" placeholder={""} className=' w200 ' req='1' firstUp="0" />
                                            </div>

                            </div>

                            <div className="form_split"></div>

                                            <div className="form_control">   
                                                {
                                                      props.status == "aktywny" &&
                                                      <div className="btn" onClick={saveData}>zapisz</div>  
                                                }                                         
                                                                                          
                                            </div>

                            </div>




                    <br/>
                    <br/>

                    {
                        emps != null &&
                        <Fragment>
                            <div>



                                                        <h3>Nauczyciele / pracownicy</h3>

                                                        
                                                    <div className="form_control p100">
                                                                <div className="fieldName">Podaj imię i nazwisko by przypisać nauczyciela</div>
                                                                <InputSearchEmp userData={props.userData} mainView={props.mainView}   value={newEmp} err={errTab}  valChange={valChangeListenerEmp} goNext={null} name="newEmp" placeholder={""} className=' w200  ' req='10' firstUp="0" />
                                                        </div>

                                                        <div className="scorll_x">

                                                                <table className="table">
                                                                            
                                                                                <tbody>

                                                                                        {
                                                                                            emps.map( (row, inx) => {
                                                                                                
                                                                                                   var rowStyle = " row ";
                                                                                                if(inx % 2 == 0 )rowStyle = " row2 ";

                                                                                                return <tr className={rowStyle}>
                                                                                                    <td>{inx+1}</td>                                                                                          
                                                                                                    <td>{row.nazwisko + " " + row.imie}</td>    
                                                                                                     <MenuTable>
                                                                                                        <ul>
                                                                                                    
                                                                                                            <li  onClick={delEmp}  id={row.id}  >ukryj</li>
                                                                                                        
                                                                                                        </ul>                                                               
                                                                                                    </MenuTable>                                                                                               
                                                                                                </tr>

                                                                                            } )
                                                                                        }

                                                                                </tbody>
                                                                    </table>

                                                        </div>

                                                    
                                                </div>
                        </Fragment>
                    }


                    <br/>
                    <br/>

                    {
                        tab != null &&
                        <Fragment>
                            <div>
                                                        <h3>Historia zdarzeń</h3>
                                                         <p>
                                                           § 21. 3. Prowadzenie dziennika elektronicznego wymaga:  rejestrowania historii zmian i ich autorów;
                                                         </p>

                                                        <div className="scorll_x scroll200">

                                                                <table className="table">
                                                                            
                                                                                <tbody>

                                                                                        {
                                                                                            tab.map( (row, inx) => {
                                                                                                
                                                                                                var rowStyle = " row ";
                                                                                                if(inx % 2 == 0 )rowStyle = " row2 ";

                                                                                                return <tr className={rowStyle}>
                                                                                                    <td>{inx+1}</td>
                                                                                                    <td>{row.created_at}</td>
                                                                                                    <td>{row.nazwisko + " " + row.imie}</td>
                                                                                                    <td>{row.tytul}</td>
                                                                                                </tr>

                                                                                            } )
                                                                                        }

                                                                                </tbody>
                                                                    </table>

                                                        </div>

                                                    
                                                </div>
                        </Fragment>
                    }
               
               



                </Fragment>
              }


                

     </div>

 
}